// ∑: Variants column labels (FIG-325 / REQ-060, FIG-345 · UC-232). One set of
// rules for the on-screen table and the downloaded CSV, so the two can't
// drift. Display only: the column keys (sent to the server as column filters,
// used for totals and as row keys in exports) never change. No imports, so the
// export edge function (background-report-export-v8) uses this file too.

/** Columns whose on-screen name differs from the key (CONFIRMED 16 Oct). */
export const HEADER_RENAMES: Readonly<Record<string, string>> = {
  '∑: Units Sold': 'Units (12 Mnth)',
  'Stock Held': 'Inv Available',
  'Fee Allocation $': 'Fees',
};

/** Money columns are the keys that end in "$". */
export const isMoneyColumn = (key: string): boolean => /\s*\$$/.test(key);

/**
 * The on-screen header for a data column (not the Sold as / Bought as / Variant
 * identifier columns, which the table labels itself). Money headers carry no
 * "$" on screen (it is in each cell); "AVG" reads "Avg".
 */
export function screenHeaderForColumn(key: string): string {
  if (HEADER_RENAMES[key]) return HEADER_RENAMES[key];
  const header = key.replace(/\s*\$$/, '').replace(/^AVG\b/, 'Avg');
  return header.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
}

/**
 * The CSV header for a column: the on-screen header, plus " $" on money
 * columns (DECIDED 20 Oct, e.g. "Sold Payables $"). Columns in `keepAsIs`
 * (identifier columns such as "Sold as" / "Bought as") keep their exact name.
 */
export function csvHeaderForColumn(key: string, keepAsIs: ReadonlySet<string> = new Set()): string {
  if (keepAsIs.has(key)) return key;
  const label = screenHeaderForColumn(key);
  return isMoneyColumn(key) ? `${label} $` : label;
}
